import { faComment } from '@fortawesome/pro-solid-svg-icons';
import { Modal, ModalCloseButton, ModalFooter } from '@tryhackme/thm-ui-components';
import { useState } from 'react';
import { NoCommentsContainer, StyledFontAwesomeCommentIcon, StyledModalDescription, StyledModalTitle } from './modal.styles';
import type { CommentModalProps } from './modal.types';
export const CommentsModal = ({
  comments,
  triggerElement,
  onClose
}: CommentModalProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  return <Modal open={isOpen} triggerElement={triggerElement} onOpenChange={open => {
    setIsOpen(open);
    if (!open) {
      onClose();
    }
  }} data-sentry-element="Modal" data-sentry-component="CommentsModal" data-sentry-source-file="comments-modal.tsx">
      <StyledModalTitle data-sentry-element="StyledModalTitle" data-sentry-source-file="comments-modal.tsx">Comments</StyledModalTitle>
      {comments && comments?.length === 0 ? <NoCommentsContainer>There are no comments about this submission yet.</NoCommentsContainer> : comments?.map((comment: string) => <StyledModalDescription key={comment}>
            <StyledFontAwesomeCommentIcon icon={faComment} />
            {comment}
          </StyledModalDescription>)}
      <ModalFooter isSmall data-sentry-element="ModalFooter" data-sentry-source-file="comments-modal.tsx">
        <ModalCloseButton text="Close" data-sentry-element="ModalCloseButton" data-sentry-source-file="comments-modal.tsx" />
      </ModalFooter>
    </Modal>;
};